export enum WelcomeEmailStatus {
  WE_SENT = "WE Sent",
  WE_HOLD = "WE Hold",
  WE_RTS = "WE RTS",
  WE_CREATED = "WE Created",
}
